<div class="loading" *ngIf="!loading">
  <div class="loading-brand">
    <img src="assets/img/logofta.svg" alt="brand" class="brand">
  </div>
  <div class="spinner-border spinner-border-sm" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<div class="loading" *ngIf="loading">
  <div class="loading-brand">
    <img src="assets/img/logofta.svg" alt="brand" class="brand">
  </div>
  <span class="loading-error">{{message}}</span>
  <button *ngIf="!sesion" type="button" class="btn btn-primary mt-3" (click)="returnLogin()">Volver al inicio</button>
  <a *ngIf="sesion" class="login-option-btn" [href]="cidiUrl">
    <img src="{{logoCidi}}" width="110px" class="login-option-img" alt="cidi">
  </a>
</div>
